module.exports = __webpack_public_path__ + "img/4ea6aae0-793f-443c-9b38-caf924956886.d9a141ba.png";